import axios from '~/utils/axios';
import { Account, Amount } from '~/types';
import { HeadTransaction } from '~/types/HeadTransaction';

export interface RefundRejectedCheck {
  available: boolean;
  reason?: string;
  amount?: Amount;
  recipientAccounts?: Account[];
}

interface checkProps {
  transactionId: string;
}

export const check = ({ transactionId }: checkProps) => {
  return axios.post<RefundRejectedCheck>('/transactionRefundRejected/check', { transactionId });
};

interface createConsentProps {
  transactionId: string;
  recipientAccountId: string;
  reason: string;
}

export const createConsent = ({
  transactionId,
  recipientAccountId,
  reason,
}: createConsentProps) => {
  return axios.post<HeadTransaction>('/transactionRefundRejected/consent', {
    transactionId,
    recipientAccountId,
    reason,
  });
};

interface createTransactionProps {
  consentId: string;
}

export const createTransaction = ({ consentId }: createTransactionProps) => {
  return axios.post<HeadTransaction>('/transactionRefundRejected', { consentId });
};
